import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    LoyaltyNumber: {
      validations: []
    },
    eventextra1: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    starttime: {
      validations: []
    },
    endtime: {
      validations: []
    },
    eventextra5: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    clientName: {
      validations: [
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of characters reached' }
      ]
    },
    partyname: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    eventextra4: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    sitename: {
      validations: []
    },
    plannedguestcount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide a guest count in numbers only.'},
      ]
    },
    PONumber: {
      validations: []
    },
    eventextra2: {
      validations: []
    },
    eventextra3: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Event Details:',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Hospitality Request Number:',
            mapping: 'LoyaltyNumber'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Requested Department:',
            mapping: 'eventextra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventDate'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Start Time:',
            options: [
              { label: '6:00 AM'  , value: '06:00:00'},
              { label: '6:30 AM'  , value: '06:30:00'},
              { label: '7:00 AM'  , value: '07:00:00'},
              { label: '7:30 AM'  , value: '07:30:00'},
              { label: '8:00 AM'  , value: '08:00:00'},
              { label: '8:30 AM'  , value: '08:30:00'},
              { label: '9:00 AM'  , value: '09:00:00'},
              { label: '9:30 AM'  , value: '09:30:00'},
              { label: '10:00 AM' , value: '10:00:00'},
              { label: '10:30 AM' , value: '10:30:00'},
              { label: '11:00 AM' , value: '11:00:00'},
              { label: '11:30 AM' , value: '11:30:00'},
              { label: '12:00 PM' , value: '12:00:00'},
              { label: '12:30 PM' , value: '12:30:00'},
              { label: '1:00 PM'  , value: '13:00:00'},
              { label: '1:30 PM'  , value: '13:30:00'},
              { label: '2:00 PM'  , value: '14:00:00'},
              { label: '2:30 PM'  , value: '14:30:00'},
              { label: '3:00 PM'  , value: '15:00:00'},
              { label: '3:30 PM'  , value: '15:30:00'},
              { label: '4:00 PM'  , value: '16:00:00'},
              { label: '4:30 PM'  , value: '16:30:00'},
              { label: '5:00 PM'  , value: '17:00:00'},
              { label: '5:30 PM'  , value: '17:30:00'},
              { label: '6:00 PM'  , value: '18:00:00'},
              { label: '6:30 PM'  , value: '18:30:00'},
              { label: '7:00 PM'  , value: '19:00:00'},
              { label: '7:30 PM'  , value: '19:30:00'},
              { label: '8:00 PM'  , value: '20:00:00'},
              { label: '8:30 PM'  , value: '20:30:00'},
              { label: '9:00 PM'  , value: '21:00:00'},
              { label: '9:30 PM'  , value: '21:30:00'},
              { label: '10:00 PM' , value: '22:00:00'},
              { label: '10:30 PM' , value: '22:30:00'},
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM', value: '00:00:00' },
              { label: '12:30 AM', value: '00:30:00' },
              { label: '1:00 AM', value: '01:00:00' },
              { label: '1:30 AM', value: '01:30:00' },
              { label: '2:00 AM', value: '02:00:00' },
            ],
            mapping: 'starttime'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event End Time:',
            options: [
              { label: '6:00 AM'  , value: '06:00:00'},
              { label: '6:30 AM'  , value: '06:30:00'},
              { label: '7:00 AM'  , value: '07:00:00'},
              { label: '7:30 AM'  , value: '07:30:00'},
              { label: '8:00 AM'  , value: '08:00:00'},
              { label: '8:30 AM'  , value: '08:30:00'},
              { label: '9:00 AM'  , value: '09:00:00'},
              { label: '9:30 AM'  , value: '09:30:00'},
              { label: '10:00 AM' , value: '10:00:00'},
              { label: '10:30 AM' , value: '10:30:00'},
              { label: '11:00 AM' , value: '11:00:00'},
              { label: '11:30 AM' , value: '11:30:00'},
              { label: '12:00 PM' , value: '12:00:00'},
              { label: '12:30 PM' , value: '12:30:00'},
              { label: '1:00 PM'  , value: '13:00:00'},
              { label: '1:30 PM'  , value: '13:30:00'},
              { label: '2:00 PM'  , value: '14:00:00'},
              { label: '2:30 PM'  , value: '14:30:00'},
              { label: '3:00 PM'  , value: '15:00:00'},
              { label: '3:30 PM'  , value: '15:30:00'},
              { label: '4:00 PM'  , value: '16:00:00'},
              { label: '4:30 PM'  , value: '16:30:00'},
              { label: '5:00 PM'  , value: '17:00:00'},
              { label: '5:30 PM'  , value: '17:30:00'},
              { label: '6:00 PM'  , value: '18:00:00'},
              { label: '6:30 PM'  , value: '18:30:00'},
              { label: '7:00 PM'  , value: '19:00:00'},
              { label: '7:30 PM'  , value: '19:30:00'},
              { label: '8:00 PM'  , value: '20:00:00'},
              { label: '8:30 PM'  , value: '20:30:00'},
              { label: '9:00 PM'  , value: '21:00:00'},
              { label: '9:30 PM'  , value: '21:30:00'},
              { label: '10:00 PM' , value: '22:00:00'},
              { label: '10:30 PM' , value: '22:30:00'},
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM', value: '00:00:00' },
              { label: '12:30 AM', value: '00:30:00' },
              { label: '1:00 AM', value: '01:00:00' },
              { label: '1:30 AM', value: '01:30:00' },
              { label: '2:00 AM', value: '02:00:00' },
            ],
            mapping: 'endtime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Requester Full Name:*',
            mapping: 'eventextra5'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Client/Organization:',
            mapping: 'clientName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Title:',
            mapping: 'partyname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Request Email:*',
            mapping: 'email'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telNumber'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'IMI Proponent Email:*',
            mapping: 'eventextra4'
              }
            ]
          },
          {
            fields: [
              {
            type: 'text',
            size: 'Medium',
            label: 'Venue:',
            mapping: 'sitename'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Numbers of Guests:',
            mapping: 'plannedguestcount'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Total Number of IMI Employees:',
            mapping: 'PONumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Meal Type:',
            options: [
              { label: 'Working Lunch Buffet Type 1 (Option A)', value: 'Working Lunch Buffet Type 1 (Option A)'},
              { label: 'Working Lunch Buffet Type 1 (Option B)', value: 'Working Lunch Buffet Type 1 (Option B)'},
              { label: 'Working Lunch Buffet Type 2 (Option A)', value: 'Working Lunch Buffet Type 2 (Option A)'},
              { label: 'Working Lunch Buffet Type 2 (Option B)', value: 'Working Lunch Buffet Type 2 (Option B)'},
              { label: 'Plated Lunch Preset (Option A)', value: 'Plated Lunch Preset (Option A)'},
              { label: 'Plated Lunch Preset (Option B)', value: 'Plated Lunch Preset (Option B)'},
              { label: 'Plated Lunch Special Menu (Option A)', value: 'Plated Lunch Special Menu (Option A)'},
              { label: 'Plated Lunch Special Menu (Option B)', value: 'Plated Lunch Special Menu (Option B)'},
              { label: 'VIP Lunch/Dinner Buffet (Option A)', value: 'VIP Lunch/Dinner Buffet (Option A)'},
              { label: 'VIP Lunch/Dinner Buffet (Option B)', value: 'VIP Lunch/Dinner Buffet (Option B)'},
              { label: 'VIP Lunch/Dinner Buffet (Option C)', value: 'VIP Lunch/Dinner Buffet (Option C)'},
              { label: 'VIP Lunch/Dinner Buffet (Option D)', value: 'VIP Lunch/Dinner Buffet (Option D)'},
              { label: 'VIP Lunch/Dinner Buffet (Option E)', value: 'VIP Lunch/Dinner Buffet (Option E)'},
              { label: 'VIP Lunch/Dinner Buffet (Option F)', value: 'VIP Lunch/Dinner Buffet (Option F)'},
              { label: 'VVIP Lunch/Dinner (Option A)', value: 'VVIP Lunch/Dinner (Option A)'},
              { label: 'VVIP Lunch/Dinner (Option B)', value: 'VVIP Lunch/Dinner (Option B)'},
              { label: 'VVIP Lunch/Dinner (Option C)', value: 'VVIP Lunch/Dinner (Option C)'},
            ],
            mapping: 'eventextra2'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Refreshment Type:',
            options: [
              { label: 'Light Office Refreshment Standard Menu (A)', value: 'Light Office Refreshment Standard Menu (A)'},
              { label: 'Light Office Refreshment Standard Menu (B)', value: 'Light Office Refreshment Standard Menu (B)'},
              { label: 'Light Office Refreshment Standard Menu (C)', value: 'Light Office Refreshment Standard Menu (C)'},
              { label: 'Senior Office Refreshment Business Menu(A)', value: 'Senior Office Refreshment Business Menu(A)'},
              { label: 'Senior Office Refreshment Business Menu(B)', value: 'Senior Office Refreshment Business Menu(B)'},
              { label: 'Senior Office Refreshment Business Menu(C)', value: 'Senior Office Refreshment Business Menu(C)'},
              { label: 'VIP Refreshment Standard Menu(A)', value: 'VIP Refreshment Standard Menu(A)'},
              { label: 'VIP Refreshment Standard Menu(B)', value: 'VIP Refreshment Standard Menu(B)'},
              { label: 'VIP Refreshment Standard Menu(C)', value: 'VIP Refreshment Standard Menu(C)'},
              { label: 'VVIP Refreshment Business Menu(A)', value: 'VVIP Refreshment Business Menu(A)'},
              { label: 'VVIP Refreshment Business Menu(B)', value: 'VVIP Refreshment Business Menu(B)'},
              { label: 'VVIP Refreshment Business Menu(C)', value: 'VVIP Refreshment Business Menu(C)'},
              { label: 'Cake', value: 'Cake'},
              { label: 'Beverage', value: 'Beverage'},
            ],
            mapping: 'eventextra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Tamimi Group Contact Us Form',
    formId: '2167',
    clientKey: 'DE61890C-4AE7-4DA5-A46E-E25CA16B68C5',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you for booking a hospitality event with Tamimi. We will get back to you within 24 business hours. If you have any queries regarding your event request, please reach out to tamimi_imi@al-tamimi.com.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
